import React, {useContext, useState} from 'react';
import {Context} from "../store/reducer";

/**
 * 96_1 建築確認番号（三次市）の同意ウィンドウ
 * 
 * @returns 
 */
const Component = () => {

    const { state, dispatch } = useContext(Context);
    let [isOpened, setIsOpened] = useState(true);

    /**
     * 同意した場合はフラグをtrueにする。
     */
    const agree = () => {

        dispatch({
            type    : 'SET_VIS93_MODAL_AGREE',
            category: "vis_96_1"
        })
        
        setIsOpened(false)
    }
    
    const disAgree = () => {
        setIsOpened(false)
    }

    return (isOpened && <>
        <div class="modal-first">
            <div class="modal-first-inner">

                <h3 className="u-fs-16 u-txt-c u-pb-xs u-lh-sm">確認済証番号を公開します。</h3>

                <section className="u-pb-xs">
                    <h5 style={{}}>目的</h5>
                    <p>都市計画法第６条に基づき実施している、都市計画基礎調査情報（現在、最新は令和３年４月時点）の最新性を確保することを目的に公開しています。
                    </p>
                </section>

                <section className="u-pb-xs">
                    <h5 style={{}}>利用用途</h5>
                    <p>地図上のポイントデータから、確認済証番号を確認することが可能です。「建築計画概要書の閲覧」の際に、この確認済証番号を特定行政庁等に示すことで、円滑な閲覧申請等が可能となります。
                    </p>
                </section>

                <section className="u-pb-xs">
                    <h5 style={{}}>確認済証番号</h5>
                    <p>次の確認済証番号を公開します。</p>
                    
                    <ul>
                        <li>・特定行政庁及び指定確認検査機関で建築確認のあったもの</li>
                        <li>・令和６年度以降に建築確認のあったもの<br />
                            （建物位置が座標値により特定できるものを公開しています。）
                        </li>
                    </ul>
                </section>

                <section className="u-pb-xs">
                    <h5 style={{}}>公開対象の市町</h5>
                    <p>（市管轄）福山市、呉市、尾道市、三次市</p>
                    <p>（県管轄）<br />
                        西部建設事務所管内：竹原市、大竹市、江田島市、府中町、海田町、熊野町、坂町、
                        安芸太田町、北広島町、大崎上島町<br />
                        東部建設事務所管内：府中市、世羅町、神石高原町<br />
                        北部建設事務所管内：三次市、庄原市、安芸高田市</p>
                    <p>※ その他については、直接、担当の特定行政庁でご確認ください。</p>
                </section>
                 
                <section className="u-pb-xs">
                    <h5 style={{}}>ご利用上の注意</h5>
                    <p>ご利用に際しましては、次の記載事項の内容に同意の上、閲覧してください。</p>
                    <ul>
                        <li>１．確認済証番号の公開は、周辺住民の協力のもとに違反建築を未然に防止するとともに、併せて無確認建築物・違反建築物の売買を防止することを目的に行われる「建築計画概要書の閲覧」を補助するものとして行うものです。したがって、この目的以外の利用や営利目的での利用はお断りします。</li>
                        <li>２．地図上のポイントは参考としていただくために作成しています。確認申請時の地名地番や附近見取図を参考に作成しているため、現地の建物の位置と一致していない場合があります。正確な情報が必要な場合は、所管する特定行政庁等の窓口でご確認ください。</li>
                        <li>３．本データは、令和７年３月末時点までの申請によるもので、順次更新して追加していきます。常に最新の情報とはなっていません。</li>
                        <li>４．地図の精度及びデータ入力による誤差を含んでいます。</li>
                        <li>５．本データの全部または一部を無断で複写、複製、転載、ファイル化し利用することを禁じます。</li>
                        <li>６．広島県及び公開対象市町は、本データの利用により発生する直接又は間接の損失・損害等について、一切の責任を負いません。</li>
                    </ul>
                </section>          

                <h4>上記利用上の注意事項について、全て同意しますか。</h4>

                <p className="u-txt-c" onClick={agree} style={{ cursor: 'pointer' }} ><span style={{"text-decoration": "underline"}}>同意します</span></p>
                <p className="u-txt-c" onClick={disAgree} style={{fontSize:"0.7em", cursor: 'pointer' }}><span style={{"text-decoration": "underline"}}>同意しません</span></p>
            </div>
        </div>
    </>);
}

export default Component
